module.exports = __webpack_public_path__ + "media/images/site/close-307239bbe79217b328d2d27eb1318bdf.svg";